export default __webpack_public_path__ + "static/media/happy_hour.a4c85a06.png";